import { useEffect, useState } from "react";
import "./CustomPowerFactorRedChart.css";
import Chart from "react-apexcharts";

const CustomPowerFactorRedChart = (props) => {
    const [chartconfig5, setChartconfig5] = useState();
    useEffect(() => {
        setChartconfig5({
            options: {
                chart: {
                    id: "basic-bar"
                },
                xaxis: {
                    categories: props.time,
                    title: {
                        text: "Time"
                    }
                },
                yaxis: {
                    title: {
                        text: "PowerFactor"
                    }
                },
                title:{
                    text:"PowerFactor wrt to Time",
                    align:"center"
                },
                legend:{
                    show:true
                },
                dataLabels:{
                    enabled:true
                }
            },
            series: [
                {
                    name: "series-1",
                    data: props.value
                }
            ]
        });
        
    }, [props]);
    return (
        <div>
            {chartconfig5 ? <Chart
                options={chartconfig5.options}
                series={chartconfig5.series}
                type="line"
                width="500"
                
            />:null}
        </div>
    );
}

export default CustomPowerFactorRedChart;